import React, { ReactNode } from 'react';
import {
	Select as SelectCore,
	SelectProps as EnigmaSelectProps,
} from '@phonepe/enigma-ui';

export interface CustomSelectProps {
	classes?: {
		selectWrapper?: string;
	};
	children?: ReactNode;
}
const { Option } = SelectCore;
export type SelectProps = EnigmaSelectProps & CustomSelectProps;

const Select: React.FC<SelectProps> = ({
	children = null,
	classes = {},
	...restProps
}) => {
	return (
		<div className={classes.selectWrapper}>
			<SelectCore {...restProps}>{children}</SelectCore>
		</div>
	);
};

export { Select, Option };
